module.exports = __webpack_public_path__ + "img/example-store-screenshot.6b47ea61.jpeg";